require('angular-cookies')
import sessionStorage from 'sessionstorage'

angular.module('clientDashboardApp.auth.authTokenStore', ['ngCookies']).factory("authTokenStore", AuthTokenStore);

AuthTokenStore.$inject = ['$window', '$cookies']
function AuthTokenStore($window, $cookies) {

  const noop = () => null

  const tryAndRecover = (tryTo, recoverWith = noop, finallyDo = noop) => {
    let result
    try {
      result = tryTo()
    } catch (e) {
      result = recoverWith()
    } finally {
      finallyDo()
    }
    return result
  }

  const AUTH_TOKEN = 'authToken'
  const SSO_TOKEN = 'ssoToken'

  return {
    setUserAuthToken: function (authToken) {
      tryAndRecover(
        () => $window.localStorage.token = authToken,
        () => $cookies.put(AUTH_TOKEN, authToken)
      )
    },
    deleteUserAuthToken: function () {
      tryAndRecover(
        () => delete $window.localStorage.token,
        noop,
        () => $cookies.remove(AUTH_TOKEN)
      )
    },
    getUserAuthToken: function () {
      if ($window.localStorage.token) {
        return $window.localStorage.token
      }
      if ($cookies.get(AUTH_TOKEN)) {
        return $cookies.get(AUTH_TOKEN)
      }
      return null
    },

    setSSOAuthToken: authToken => sessionStorage.setItem(SSO_TOKEN, authToken),
    getSSOAuthToken: () => sessionStorage.getItem(SSO_TOKEN) || null,
    deleteSSOAuthToken: () => {console.log("Deleting SSO token1"); sessionStorage.removeItem(SSO_TOKEN)}
  }

}
